// base react-slick 0.23.2
import Slider from './slider';

export default Slider;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-slick/src/index.js
// module id = 851
// module chunks = 0